export const API_URL = (process.env.REACT_APP_API_URL || "")
  .replace(/\/+$/, "")
  .replace(/\/api$/i, "");
// Socialyorix's own social profiles, shown on the sign-in pages. Set REACT_APP_SOCIAL_* to enable each one.
const safeProfileUrl = (value) => {
  try {
    const url = new URL(String(value || "").trim());
    return url.protocol === "https:" ? url.href : "";
  } catch {
    return "";
  }
};
export const SOCIAL_LINKS = [
  ["Instagram", "ti-brand-instagram", process.env.REACT_APP_SOCIAL_INSTAGRAM],
  ["Facebook", "ti-brand-facebook", process.env.REACT_APP_SOCIAL_FACEBOOK],
  ["LinkedIn", "ti-brand-linkedin", process.env.REACT_APP_SOCIAL_LINKEDIN],
  ["X", "ti-brand-x", process.env.REACT_APP_SOCIAL_X],
  ["YouTube", "ti-brand-youtube", process.env.REACT_APP_SOCIAL_YOUTUBE]
].map(([name, icon, url]) => ({ name, icon, url: safeProfileUrl(url) })).filter((link) => link.url);

// Public marketing home that the logo links to. In development the marketing site (port 3000) proxies the
// app routes, so "/" loaded as a full page is the marketing home; set REACT_APP_MARKETING_URL when the
// marketing site lives on a different origin.
export const MARKETING_URL = String(process.env.REACT_APP_MARKETING_URL || "").trim().replace(/\/+$/, "") || "/";
